"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const media_1 = require("./media");
const multiUpload_1 = require("./media/multiUpload");
const react_hook_form_1 = require("react-hook-form");
const MultiFileSchemaComponent = (props) => {
    const { schema, control } = props;
    const { field: filesField } = (0, react_hook_form_1.useController)({
        name: schema.filesFieldPath || "",
        control: control,
    });
    const { register } = (0, react_hook_form_1.useFormContext)();
    const [errors, setErrors] = (0, react_1.useState)([]);
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
        (value, context) => __awaiter(void 0, void 0, void 0, function* () {
            return errors.some((error) => !!error) ? "エラーがあります" : null;
        }),
    ]);
    const { append, remove } = (0, react_hook_form_1.useFieldArray)({
        control,
        name: schema.filesFieldPath || "",
    });
    const { rootPath, maxHeight, accept, isUniqueFileName, fileNameFieldPath, filesFieldPath, fileValidators, } = schema;
    const handleRemove = (index) => {
        remove(index);
        setErrors((prev) => {
            const next = [...prev];
            next.splice(index, 1);
            return next;
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
            react_1.default.createElement(multiUpload_1.MultiUpload, Object.assign({}, registerProps, { register: register, filesFieldPath: filesFieldPath || "", onChange: (values) => {
                    registerProps.onChange(values);
                }, values: value, files: filesField.value, hasError: fieldState.invalid, rootPath: rootPath, accept: accept, mode: "filename", onFiles: (files) => {
                    append(files);
                }, onRemove: handleRemove, disposition: "attachment", isUniqueFileName: isUniqueFileName, fileNameFieldPath: fileNameFieldPath, errors: errors, setErrors: setErrors, validators: fileValidators })))));
};
MultiFileSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("MultiFileDisplayComponent", (value, schema) => {
    const { maxHeight } = schema;
    return (react_1.default.createElement(react_1.default.Fragment, null, value &&
        Array.isArray(value) &&
        value.map((file, index) => (react_1.default.createElement(media_1.File, { key: index, style: {
                backgroundColor: "#fff",
                maxHeight,
                marginBottom: "10px",
            }, src: file })))));
});
exports.default = MultiFileSchemaComponent;
